<template>
  <card class="no-border-card card-instructions">
    <template slot="header">
      <h3>Additional Notes</h3>
    </template>
    <div v-html="recipeData.notes"></div>
  </card>
</template>
<script>

  export default {
    title: "recipe-notes",
    props: ['recipeData'],
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
      onCreated() {
      }
    },
    created(){
      this.onCreated();
    },
    mounted() {
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
